angular.module('app.directives').directive('backhaulGraph', ($timeout, $window, StatsService) =>
    ({
        restrict: 'E',
        scope: {
            boxcasterId: '@',
            startsAt: '@',
            stopsAt: '@'
        },
        controller($scope) {
            $scope.timeoutId = null;
            $scope.hovering = false;
            $scope.statsData = null;
            $scope.packetsOptions = {
                renderer: 'multi',
                interpolation: 'step-after',
                height: 75,
                min: 0
            };
            $scope.packetsSeries = [{
                name: 'sent',
                renderer: 'area',
                data: [],
                color: 'rgba(8,61,119, 0.8)'
            }, {
                name: 'resent',
                renderer: 'area',
                data: [],
                color: 'rgba(64,61,119, 0.6)'
            }, {
                name: 'lost',
                renderer: 'stack',
                stack: false,
                data: [],
                color: 'rgb(149,61,81)'
            }];
            $scope.rttTcpOptions = {
                renderer: 'multi',
                interpolation: 'step-after',
                height: 60,
                min: 0
            };
            $scope.rttTcpSeries = [{
                name: 'rtt',
                renderer: 'line',
                data: [],
                color: 'rgba(238,150,75,1.0)'
            }, {
                name: 'rtt+1s',
                renderer: 'line',
                data: [],
                color: 'rgba(238,150,75,0.5)'
            }, {
                name: 'rtt-1s',
                renderer: 'line',
                data: [],
                color: 'rgba(238,150,75,0.5)'
            }, {
                name: 'tcp-open',
                renderer: 'area',
                data: [],
                color: 'rgba(235,235,75, 0.3)'
            }];
            $scope.videoBitrateOptions = {
                renderer: 'multi',
                interpolation: 'step-after',
                height: 60,
                min: 0
            };
            $scope.videoBitrateSeries = [{
                name: 'target',
                renderer: 'line',
                data: [],
                color: 'rgba(249,87,56,1.0)'
            }, {
                name: 'actual',
                renderer: 'line',
                data: [],
                color: 'rgba(249,87,56,0.5)'
            }];
            $scope.audioBitrateOptions = {
                renderer: 'multi',
                interpolation: 'step-after',
                height: 60,
                min: 0
            };
            $scope.audioBitrateSeries = [{
                name: 'target',
                renderer: 'line',
                data: [],
                color: 'rgba(50,147,111,1.0)'
            }, {
                name: 'actual',
                renderer: 'line',
                data: [],
                color: 'rgba(50,147,111,0.5)'
            }];
            $scope.latencyOptions = {
                renderer: 'line',
                interpolation: 'step-after',
                height: 60,
                min: 0
            };
            $scope.latencySeries = [{
                name: 'latency',
                data: [],
                color: 'rgba(8,61,119, 0.8)'
            }];

            // This data represents the individual stats for the specific time being shown.
            $scope.statsAtTime = {
                time: null,
                packets: {},
                rttMs: null,
                tcpStatus: null,
                video: {},
                audio: {},
                latencyMs: null
            };

            return $scope.$on('$destroy', function() {
                if ($scope.timeoutId != null) {
                    return $timeout.cancel($scope.timeoutId);
                }
            });
        },

        link(scope, element, attrs) {
            // Convenience method to get stats values from one or more keys
            let statsForTime = (keys, time) =>
                _.map(keys, k => (scope.statsData[k] || {})[time]).reduce(function(a, b) {
                    if (((a === null) || (a === undefined)) && ((b === null) || (b === undefined))) {
                        return null;
                    } else if (((a !== null) && (a !== undefined)) && ((b === null) || (b === undefined))) {
                        return a;
                    } else if (((a === null) || (a === undefined)) && ((b !== null) && (b !== undefined))) {
                        return b;
                    } else {
                        return a + b;
                    }
                });

            // This function is a common function to show the BoxCaster stats for a specific moment in
            // time, based on either hovering over the chart, or showing the latest value.
            //
            // The 'pct' parameter should be a float value between 0 and 1 (inclusive) representing
            // where, in the time window, data values should be shown.
            let showGraphStats = function(pct) {
                // Update the time we're showing based on pct.
                let times = _.keys(scope.statsData[_.keys(scope.statsData)[0]]);
                times.sort((a, b) => a - b);
                let time = times[Math.round(pct * (times.length - 1))];
                scope.statsAtTime.time = time;

                // This block of code pulls out all the individual stats that are used below in the
                // templates. Most of these are numeric, but some are converted to boolean.
                scope.statsAtTime.packets.sent = statsForTime(['pipeline.backhaul.sent.buffers'], time);
                scope.statsAtTime.packets.resent = statsForTime(['pipeline.backhaul.resent.buffers'], time);
                scope.statsAtTime.packets.lost = statsForTime(['pipeline.backhaul.lost.buffers'], time);
                scope.statsAtTime.rttMs = statsForTime(['pipeline.backhaul.rtt-us-average'], time);
                if (scope.statsAtTime.rttMs != null) {
                    scope.statsAtTime.rttMs /= 1000.0;
                }
                scope.statsAtTime.tcpStatus = statsForTime(['pipeline.backhaul.tcp-socket-open'], time);
                if (scope.statsAtTime.tcpStatus != null) {
                    let statusMap = {
                        [0]: 'Closed',
                        [1]: 'Open'
                    };
                    scope.statsAtTime.tcpStatus = statusMap[scope.statsAtTime.tcpStatus];
                }
                scope.statsAtTime.video.target = statsForTime(['pipeline.target-video-bitrate'], time);
                scope.statsAtTime.video.actual = statsForTime(['pipeline.video-byte-count'], time);
                scope.statsAtTime.audio.target = statsForTime(['pipeline.target-audio-bitrate'], time);
                scope.statsAtTime.audio.actual = statsForTime(['pipeline.audio-byte-count'], time);
                scope.statsAtTime.latencyMs = statsForTime(['pipeline.backhaul.buffer-latency-average'], time);
                if (scope.statsAtTime.latencyMs != null) {
                    return scope.statsAtTime.latencyMs /= 1000.0;
                }
            };

            // This function calculates the extents of the embedded graph area.
            let getGraphExtents = function() {
                let graphExtents = angular.copy($(element).find('td .rickshaw_graph').position());
                graphExtents.width = $(element).find('td .rickshaw_graph').width();
                graphExtents.height = $(element).find('table').height();
                return graphExtents;
            };

            // This function is called whenever the graph is hovered over (when the mouse enters or moves
            // over the graph area).
            let onGraphHoverEnter = evt =>
                scope.$apply(function() {
                    let graphExtents = getGraphExtents();
                    let offset_left = $(evt.currentTarget).parents('backhaul-graph').offset().left;
                    $(element).find('#cursor').css('left', `${evt.clientX - offset_left - 2}px`);
                    let left = evt.clientX - $(evt.currentTarget)[0].getBoundingClientRect().left;
                    $(element).find('#cursor').show();
                    let pct = (left * 1.0) / graphExtents.width;
                    if ((pct != null) && (pct >= 0.0) && (pct <= 1.0)) {
                        showGraphStats(pct);
                        return scope.hovering = true;
                    }
                });

            // This function is called whenever the mouse leaves the graph area.
            let onGraphHoverExit = evt =>
                scope.$apply(function() {
                    $(element).find('#cursor').hide();
                    showGraphStats(1.0);
                    return scope.hovering = false;
                });

            $(element).find('td.boxcaster-diagnostic-graph-cell').hover(onGraphHoverEnter, onGraphHoverExit);
            $(element).find('td.boxcaster-diagnostic-graph-cell').mousemove(onGraphHoverEnter);

            // The following keys are data that will be retrieved for display.
            scope.keys = [
                { field: 'derivative(sum("sent.buffers")) / 10', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.sent.buffers' },
                { field: '(derivative(sum("resent.nack.buffers")) + derivative(sum("resent.rtt.buffers"))) / 10', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.resent.buffers' },
                { field: 'derivative(sum("lost.buffers")) / 10', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.lost.buffers' },
                { field: 'mean("rtt-us-average")', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.rtt-us-average' },
                { field: 'mean("rtt-us-std_dev")', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.rtt-us-std_dev' },
                { field: 'last("tcp-socket-open")', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.tcp-socket-open' },
                { field: 'mean("target-video-bitrate")', value: 'boxcaster.pipeline', as: 'pipeline.target-video-bitrate' },
                { field: 'derivative(sum("video-byte-count")) * 8 / 10', value: 'boxcaster.pipeline', as: 'pipeline.video-byte-count' },
                { field: 'mean("target-audio-bitrate")', value: 'boxcaster.pipeline', as: 'pipeline.target-audio-bitrate' },
                { field: 'derivative(sum("audio-byte-count")) * 8 / 10', value: 'boxcaster.pipeline', as: 'pipeline.audio-byte-count' },
                { field: 'mean("buffer-latency-average")', value: 'boxcaster.pipeline.backhaul', as: 'pipeline.backhaul.buffer-latency-average' },
            ];
            let startsAtDate = new Date(Date.parse(scope.startsAt));
            let stopsAtDate = new Date(Date.parse(scope.stopsAt));

            // This function will be periodically called to refresh stats data.
            var refreshFn = function() {
                let req_params = { boxcaster: scope.boxcasterId, time: [`time > ${startsAtDate.getTime() / 1000}s`], targets: scope.keys };
                if (stopsAtDate.getTime() < Date.now()) {
                    req_params.time.push(`time < ${stopsAtDate.getTime() / 1000}s`);
                }
                let request = StatsService.fetch(req_params);
                return request.then(function(data) {
                    scope.statsData = data;
                    if (((new Date()) - (new Date(scope.stopsAt))) < (60 * 60 * 1000)) {
                        return scope.timeoutId = $timeout(refreshFn, 10000);
                    } else {
                        return scope.timeoutId = null;
                    }
                });
            };
            refreshFn();

            // When the window is resized, we need to manually update the child graphs' sizes, since
            // Rickshaw uses SVG, and the SVG elements themselves are particularly bad about sizing.
            angular.element($window).bind('resize', function() {
                // The actual graph width is the panel width minus the width of the first and last columns.
                let panelWidth = $(element).find('#backhaul-chart-panel')[0].getBoundingClientRect().width;
                let prevColWidth = $(element).find('#backhaul-chart-panel table tr th')[0].getBoundingClientRect().width;
                let nextColWidth = $(element).find('#backhaul-chart-panel table tr td')[1].getBoundingClientRect().width;
                let newWidth = panelWidth - prevColWidth - nextColWidth;
                return scope.$apply(function() {
                    scope.packetsOptions.width = newWidth;
                    scope.rttTcpOptions.width = newWidth;
                    scope.videoBitrateOptions.width = newWidth;
                    return scope.audioBitrateOptions.width = newWidth;
                });
            });

            element.on('$destroy', function() {
                if (scope.timeoutId != null) {
                    return $timeout.cancel(scope.timeoutId);
                }
            });

            let FILTER_COUNTER_ERROR_PERCENT = 5.0;
            return scope.$watch('statsData', function(newval, oldval) {
                if (newval != null) {
                    _.each(newval, function(values, key) {
                        if (key.match(/\.buffers/) || key.match(/\.byte-count/)) {
                            let times = _.keys(values).sort();
                            let tofix = {};
                            _.each(times, function(t, i) {
                                if ((i > 0) && (i < (times.length - 1))) {
                                    let prev = values[times[i - 1]];
                                    let val = values[t];
                                    let next = values[times[i + 1]];
                                    if ((prev !== 0) && (val === 0) && (next !== 0)) {
                                        if ((Math.abs((next * 2.0) - prev) / prev) < (FILTER_COUNTER_ERROR_PERCENT / 100.0)) { //prev =~= next * 2.0
                                            values[t] = prev / 2.0;
                                            return tofix[times[i - 1]] = values[t];
                                        } else if ((Math.abs((prev * 2.0) - next) / next) < (FILTER_COUNTER_ERROR_PERCENT / 100.0)) { //next =~= prev * 2.0
                                            values[t] = next / 2.0;
                                            return tofix[times[i + 1]] = values[t];
                                        }
                                    }
                                }
                            });
                            return _.each(tofix, (v, k) => values[k] = v);
                        } else {
                            // Remove nulls from gauges
                            return _.each(values, function(v, k) {
                                if (v == null) {
                                    return delete values[k];
                                }
                            });
                        }
                    });

                    let all_times = _.union.apply(this, _.map(_.keys(newval), k => _.keys(newval[k]))).sort((a, b) => a - b);
                    _.each(_.keys(newval), function(k) {
                        let lastValue = null;
                        return _.each(all_times, function(t) {
                            if (!_.has(newval[k], t)) {
                                newval[k][t] = lastValue || 0;
                            }
                            return lastValue = newval[k][t];
                        });
                    });

                    scope.packetsSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.packetsSeries[0].data, _.map(newval['pipeline.backhaul.sent.buffers'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.packetsSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.packetsSeries[1].data, _.map(newval['pipeline.backhaul.resent.buffers'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.packetsSeries[2].data.length = 0;
                    Array.prototype.push.apply(scope.packetsSeries[2].data, _.map(newval['pipeline.backhaul.lost.buffers'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.rttTcpSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.rttTcpSeries[0].data, _.map(newval['pipeline.backhaul.rtt-us-average'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.rttTcpSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.rttTcpSeries[1].data, _.map(_.keys(newval['pipeline.backhaul.rtt-us-average']).sort(), t => ({ x: parseInt(t), y: newval['pipeline.backhaul.rtt-us-average'][t] + newval['pipeline.backhaul.rtt-us-std_dev'][t] })));
                    scope.rttTcpSeries[2].data.length = 0;
                    Array.prototype.push.apply(scope.rttTcpSeries[2].data, _.map(_.keys(newval['pipeline.backhaul.rtt-us-average']).sort(), t => ({ x: parseInt(t), y: newval['pipeline.backhaul.rtt-us-average'][t] - newval['pipeline.backhaul.rtt-us-std_dev'][t] })));
                    scope.rttTcpOptions.max = _.max(_.pluck(scope.rttTcpSeries[1].data, 'y'));
                    scope.rttTcpSeries[3].data.length = 0;
                    Array.prototype.push.apply(scope.rttTcpSeries[3].data, _.map(newval['pipeline.backhaul.tcp-socket-open'], (v, k) => ({ x: parseInt(k), y: v * 10000000 })).sort((a, b) => a.x - b.x));
                    scope.videoBitrateSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.videoBitrateSeries[0].data, _.map(newval['pipeline.target-video-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.videoBitrateSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.videoBitrateSeries[1].data, _.map(newval['pipeline.video-byte-count'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.audioBitrateSeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.audioBitrateSeries[0].data, _.map(newval['pipeline.target-audio-bitrate'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.audioBitrateSeries[1].data.length = 0;
                    Array.prototype.push.apply(scope.audioBitrateSeries[1].data, _.map(newval['pipeline.audio-byte-count'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));
                    scope.latencySeries[0].data.length = 0;
                    Array.prototype.push.apply(scope.latencySeries[0].data, _.map(newval['pipeline.backhaul.buffer-latency-average'], (v, k) => ({ x: parseInt(k), y: v })).sort((a, b) => a.x - b.x));

                    if (!scope.hovering) { return showGraphStats(1.0); }
                }
            });
        },

        template: `\
<div class="panel panel-default">
  <div class="panel-heading">
    Backhaul <span ng-show="!!statsAtTime.time">&mdash; At {{ statsAtTime.time * 1000 | timestamp }}</span>
  </div>
  <div class="panel-body" id="backhaul-chart-panel" style="padding: 0px; position: relative;">
    <table class="table" style="width: 100%; margin: 0px;">
      <tr>
        <th class="boxcaster-diagnostic-graph-rowhead">Packets</th>
        <td class="boxcaster-diagnostic-graph-cell">
          <app-rickshaw rickshaw-options="packetsOptions" rickshaw-series="packetsSeries"></app-rickshaw>
        </td>
        <td>
          <div class="boxcaster-diagnostic-graph-value" style="width:150px">Sent: {{ statsAtTime.packets.sent | number:0 }}<br/>Re-sent: {{ statsAtTime.packets.resent | number:0 }}<br/>Un-ACKed: {{ statsAtTime.packets.lost | number:0 }}</div>
        </td>
      </tr>
      <tr>
        <th class="boxcaster-diagnostic-graph-rowhead">RTT/TCP</th>
        <td class="boxcaster-diagnostic-graph-cell">
          <app-rickshaw rickshaw-options="rttTcpOptions" rickshaw-series="rttTcpSeries"></app-rickshaw>
        </td>
        <td>
          <div class="boxcaster-diagnostic-graph-value" style="width:150px">RTT: {{ statsAtTime.rttMs | numberWithUnit:1:"ms" }}<br/>TCP: {{ statsAtTime.tcpStatus }}</div>
        </td>
      </tr>
      <tr>
        <th class="boxcaster-diagnostic-graph-rowhead">Video</th>
        <td class="boxcaster-diagnostic-graph-cell">
          <app-rickshaw rickshaw-options="videoBitrateOptions" rickshaw-series="videoBitrateSeries"></app-rickshaw>
        </td>
        <td>
          <div class="boxcaster-diagnostic-graph-value" style="width:150px">Target: {{ statsAtTime.video.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.video.actual | metricPrefix:'bps' }}</div>
        </td>
      </tr>
      <tr>
        <th class="boxcaster-diagnostic-graph-rowhead">Audio</th>
        <td class="boxcaster-diagnostic-graph-cell">
          <app-rickshaw rickshaw-options="audioBitrateOptions" rickshaw-series="audioBitrateSeries"></app-rickshaw>
        </td>
        <td>
          <div class="boxcaster-diagnostic-graph-value" style="width:150px">Target: {{ statsAtTime.audio.target | metricPrefix:'bps' }}<br/>Actual: {{ statsAtTime.audio.actual | metricPrefix:'bps' }}</div>
        </td>
      </tr>
      <tr>
        <th class="boxcaster-diagnostic-graph-rowhead">Latency</th>
        <td class="boxcaster-diagnostic-graph-cell">
          <app-rickshaw rickshaw-options="latencyOptions" rickshaw-series="latencySeries"></app-rickshaw>
        </td>
        <td>
          <div class="boxcaster-diagnostic-graph-value" style="width:150px">Latency: {{ statsAtTime.latencyMs | numberWithUnit:1:"ms" }}</div>
        </td>
      </tr>
    </table>
    <div id="cursor" class="cursor"></div>
  </div>
</div>\
`
    }));


// WEBPACK FOOTER //
// ./directives/backhaul_graph.js